module.exports = __webpack_public_path__ + "img/lair-truss-arch.3951de8e.jpeg";